<template>
    <InvoicePayment
        v-if="loaded"
        :invoices="invoices"
        :show="show"
        :client-secret="paymentIntentSecret"
        :saved-payment-info="savedPaymentInfo"
        :show-default-payment-option="hasClientRole"
        @update:show="$emit('update:show', $event)"
        @getPaymentIntent="setPaymentIntent($event)"
    />
</template>
<script>
import Vue from "vue";
import swal from "sweetalert2";
import { StripePlugin } from "@vue-stripe/vue-stripe";
import { mapActions } from "vuex";
import InvoicePayment from "./_components/InvoicePayment";
import { getters } from "src/global-store.js";

export default {
    name: "InvoicePaymentModule",
    components: {
        InvoicePayment,
    },
    props: {
        invoices: {
            type: Array,
            required: true,
        },
        show: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            loaded: false,
            savedPaymentInfo: null,
            paymentIntentSecret: null,
        };
    },
    computed: {
        hasClientRole() {
            return getters.hasClientRole();
        },
    },
    async created() {
        const info = await this.checkPaymentIntentStatus();

        if (info.payable) {
            this.savedPaymentInfo = await this.getSavedPaymentInfo();
            if (this.savedPaymentInfo.length === 0) {
                this.setPaymentIntent();
            }
            this.loaded = true;
        } else {
            swal({
                title: info.title,
                buttonsStyling: false,
                text: info.message,
                confirmButtonClass: "btn btn-fill",
                type: "info",
            }).then(() => {
                this.$emit("update:show", false);
            });
        }
    },
    methods: {
        ...mapActions("invoice", [
            "getSavedPaymentInfo",
            "payInvoices",
            "getPaymentIntent",
        ]),
        async checkPaymentIntentStatus() {
            Vue.use(StripePlugin, {
                pk: process.env.VUE_APP_STRIPE_PK_KEY,
            });

            const invoice = this.invoices[0];
            if (invoice.payment_intent_client_secret) {
                const { paymentIntent } =
                    await this.$stripe.retrievePaymentIntent(
                        invoice.payment_intent_client_secret,
                    );
                if (paymentIntent.status === "requires_payment_method") {
                    return {
                        payable: true,
                    };
                }

                return {
                    payable: false,
                    title: "Payment processing...",
                    message: `You cannot pay for this invoice because we are already processing your payment of ${paymentIntent.description}. We will email you when your payment succeeds.`,
                };
            }

            return {
                payable: true,
            };
        },
        async setPaymentIntent(paymentMethodId = null) {
            const invoiceIds = this.invoices.map((i) => i.id);
            this.paymentIntentSecret = await this.getPaymentIntent({
                input: { invoiceIds, paymentMethodId },
            });

            // Payment has been sent to Stripe for processing (used saved bank account)
            if (paymentMethodId !== null) {
                this.$emit("update:show", false);
                this.$router.push({
                    path: "/invoices",
                    query: {
                        payment_intent_client_secret: this.paymentIntentSecret,
                    },
                });
            }
        },
    },
};
</script>
